"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToolTipView = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _toolTip = _interopRequireDefault(require("@bento-core/tool-tip"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
* customize tooltips based on tooltipContent
* defined on dashboardTabData (tooltipContent)
*/
var ToolTipView = function ToolTipView(props) {
  var section = props.section,
    tooltipCofig = props.tooltipCofig,
    classes = props.classes;
  var icon = tooltipCofig.icon,
    src = tooltipCofig.src,
    alt = tooltipCofig.alt,
    _tooltipCofig$arrow = tooltipCofig.arrow,
    arrow = _tooltipCofig$arrow === void 0 ? false : _tooltipCofig$arrow,
    tooltipText = tooltipCofig.tooltipText,
    placement = tooltipCofig.placement;
  return /*#__PURE__*/_react.default.createElement(_toolTip.default, {
    placement: placement,
    title: tooltipText || "".concat(tooltipCofig[section]),
    arrow: arrow,
    classes: {
      tooltip: classes.customTooltip,
      arrow: classes.customArrow
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: icon || src,
    alt: alt
  }));
};
exports.ToolTipView = ToolTipView;
var AddSelectedFileComponent = function AddSelectedFileComponent(props) {
  var eventHandler = props.eventHandler,
    title = props.title,
    clsName = props.clsName,
    disabled = props.disabled,
    tooltipCofig = props.tooltipCofig;
  var addFiles = function addFiles() {
    eventHandler();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: addFiles,
    className: clsName,
    disableRipple: true,
    disabled: disabled
  }, title), tooltipCofig && /*#__PURE__*/_react.default.createElement(ToolTipView, props));
};
var _default = AddSelectedFileComponent;
exports.default = _default;